import React from 'react';
import elencoNavigation from '../data/ElencoNavigation';

const NavigationContext = React.createContext(elencoNavigation);

export { NavigationContext as default };
